import React from "react";
import PropTypes from "prop-types";

import CardWrapper from "cards/components/CardWrapper";
import Headline from "cards/components/Headline";
import PrimaryImage from "cards/components/PrimaryImage";
import StoryBody from "components/Library/StoryBody";
import ShareLinks from "cards/components/ShareLinks";
import TextOverHeadline from "cards/components/TextOverHeadline";
import { EV_RUBRIC } from "config/constants";

import styles from "./ChunkCard.css";

export default function ChunkCard({ chunk, index }) {
  return (
    <CardWrapper ariaRole="listitem">
      <div id={`story${index}`} className={styles.anchor} />
      {chunk.is_expert_voices && (
        <TextOverHeadline rubric={EV_RUBRIC} isFeatured={false} />
      )}
      <Headline headline={chunk.headline} />
      <PrimaryImage image={chunk.primary_image} lazyload={!!index} />
      <StoryBody story={chunk} />
      <ShareLinks headline={chunk.headline} permalink={chunk.permalink} />
    </CardWrapper>
  );
}

ChunkCard.propTypes = {
  chunk: PropTypes.shape({
    id: PropTypes.string.isRequired,
    headline: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    primary_image: PropTypes.object,
    blocks: PropTypes.object,
    is_expert_voices: PropTypes.bool,
  }).isRequired,
  index: PropTypes.number.isRequired,
};
